import React, { useContext, useState } from 'react';
import { Modal } from 'edcom-ui';
import AccountContext from '../../../services/AccountContext';
import CollectionsModalFeatureWall from './CollectionsModalFeatureWall';
import CollectionsModalList from './CollectionsModalList';
import CollectionsModalCreate from './CollectionsModalCreate';
import CollectionsContext from '../../../services/CollectionsContext';
import styles from './CollectionsModal.module.less';

export const screens = {
  LIST: 'list',
  CREATE: 'create',
};

function CollectionsModal() {
  const { memberId } = useContext(AccountContext);
  const {
    ready,
    collections,
    modalIsOpen,
    setModalIsOpen,
    createCollection,
    setCurrentCollectionId,
    trackFeatureWall,
    selectedContent,
    collectContent,
    addToCollection,
  } = useContext(CollectionsContext);

  const [screen, setScreen] = useState(screens.LIST);
  const [error, setError] = useState(null);

  if (!ready) {
    return null;
  }

  const closeModal = () => setModalIsOpen(false);

  if (!memberId) {
    if (modalIsOpen) {
      trackFeatureWall();
    }
    return (
      <Modal open={modalIsOpen} onClose={closeModal} size="large">
        <CollectionsModalFeatureWall closeModal={closeModal} />
      </Modal>
    );
  }

  const handleSelectCollection = id => {
    setError(null);
    try {
      setCurrentCollectionId(id);

      if (
        selectedContent != null &&
        selectedContent.length === 1 &&
        selectedContent[0].flag === 'collectSingle'
      ) {
        collectContent(
          selectedContent[0].type,
          selectedContent[0].id,
          selectedContent[0].model,
          id
        );
      } else {
        addToCollection(selectedContent, id);
      }

      closeModal();
    } catch (e) {
      console.error(e);
      setError('There was an error selecting the collection');
    }
  };

  const handleCreateCollection = async name => {
    setError(null);
    try {
      const collection = await createCollection(name);

      handleSelectCollection(collection.id);

      setScreen(screens.LIST);
      closeModal();
    } catch (e) {
      console.error(e);
      setError('There was an error creating the collection');
    }
  };

  const cancelClickHandler = () => {
    setError(null);
    setScreen(screens.LIST);
  };

  const renderModal = () => {
    switch (screen) {
      case screens.LIST:
        return (
          <CollectionsModalList
            collections={collections}
            selectCollection={handleSelectCollection}
            showCreate={() => setScreen(screens.CREATE)}
          />
        );
      case screens.CREATE:
        return (
          <CollectionsModalCreate
            createCollection={handleCreateCollection}
            showList={cancelClickHandler}
          />
        );
    }
  };

  return (
    <Modal open={modalIsOpen} onClose={closeModal} size="medium">
      {error !== null && <span className={styles.error}>{error}</span>}
      {renderModal()}
    </Modal>
  );
}

export default CollectionsModal;
